import { between, rem } from 'polished'
import styled from 'styled-components'

export const BeforeTitle = styled.span``

export const AfterTitle = styled.span``

export const Title = styled.h2`
  letter-spacing: -1px;

  ${({ color, theme }) =>
    color &&
    `
      color: ${theme.colors[color]};
  `}

  ${({ appearance, theme }) => {
    if (appearance === 'hero') {
      return `
        font-family: ${theme.font[0]};
        font-size: ${between('32px', '60px')};

        ${AfterTitle} {
          margin-top: 8px;
          display: block;
          font-size: ${between('16px', '24px')};
          color: ${theme.colors.primary};
        }
      `
    }

    if (appearance === 'hero-tiny') {
      return `
        font-family: ${theme.font[0]};
        font-size: ${between('20px', '40px')};

        ${AfterTitle} {
          display: block;
          margin-top: 8px;
          font-size: ${between('16px', '24px')};
          line-height: 1.4;
          color: ${theme.colors.primary};
        }
      `
    }

    if (appearance === 'section') {
      return `
        text-transform: uppercase;
        font-size: ${between('18px', '32px')};
        line-height: 1.3;
      `
    }

    if (appearance === 'section-texture') {
      return `
        text-transform: uppercase;
        font-size: ${between('18px', '40px')};
        line-height: 1;
        display: flex;
        flex-direction: column;

        span {
          align-self: flex-start;
        }
      `
    }

    if (appearance === 'card-icon') {
      return `
        text-transform: uppercase;
        font-size: ${between('16px', '18px')};
        line-height: 1.3;

        ${AfterTitle} {
          display: block;
          text-transform: initial;
          letter-spacing: 0;
          font-size: ${rem(16)};
          font-family: ${theme.font[0]};
          color: ${theme.colors.dark};
        }
      `
    }

    if (appearance === 'card-module') {
      return `
        text-transform: uppercase;
        font-size: ${between('16px', '18px')};
        line-height: 1.3;

        ${AfterTitle} {
          display: block;
        }
      `
    }

    if (appearance === 'tiny') {
      return `
        text-transform: uppercase;
        font-size: ${rem(14)};
        line-height: 1.3;
      `
    }

    if (appearance === 'form') {
      return `
        color: ${theme.colors.primary};
        text-transform: uppercase;
        font-size: ${between('16px', '18px')};
        line-height: 1.4;

        ${AfterTitle} {
          display: block;
          margin-top: 8px;
          font-size: ${between('12px', '14px')};
          line-height: 1.4;
          letter-spacing: -1px;
          color: ${theme.colors.dark};
        }
      `
    }
  }}

  ${({ marginTop }) =>
    marginTop &&
    `
    margin-top: ${marginTop}px;
  `}

  ${({ marginBottom }) =>
    marginBottom &&
    `
    margin-bottom: ${marginBottom}px;
  `}

  ${({ marginRight }) =>
    marginRight &&
    `
    margin-right: ${marginRight}px;
  `}

  ${({ marginLeft }) =>
    marginLeft &&
    `
    margin-left: ${marginLeft}px;
  `}
`
